<template>
  <div
    class="editPhoneNum"
    :style="
      $route.query.type == 'PWD_BACK' && !$isFlag
        ? 'width: 80%;margin: 0.5rem auto;'
        : ''
    "
  >
    <header-item
      :title-array="titleArray"
      :is-show="headShow"
      :title-mb="titleArray[0]"
    />
    <div v-if="successFlag" class="success">
      <img src="~assets/images/accountCenter/success@2x.png" alt="" srcset="">
      <p>密码修改成功</p>
    </div>
    <div v-else class="formClass">
      <van-form class="findTwo" @submit="onSubmit">
        <p
          class="goAppeal"
          :style="$route.query.type == 'PWD_MODIFY' ? 'right: 4rem;' : ''"
          @click="goAppeal"
        >
          忘记/不再使用该号码，去申诉？
        </p>
        <van-field
          v-model="userInfo.phone"
          style="border-radius: 16px 16px 0 0"
          :label="userInfo.label"
          :readonly="userInfo.isBindPhone"
          :rules="userInfo.isBindPhone ? [] : rules.mobileRules"
        />
        <van-field
          v-model="formParams.code"
          style="border-radius: 0 0 16px 16px"
          label="短信验证码"
          maxlength="6"
          :rules="rules.codeRules"
        >
          <template #button>
            <p
              v-if="!showTime"
              style="color: #616edf; cursor: pointer"
              @click="getCode"
            >
              {{ timeMsg }}
            </p>
            <p v-else style="color: #878787; cursor: pointer">
              {{ codeTime }} S
            </p>
          </template>
        </van-field>
        <p style="padding: 0.2rem; color: #878787; width: 7rem">
          *如果一分钟内没有收到验证码请重新获取
        </p>
        <van-field
          v-model="formParams.password"
          style="border-radius: 16px 16px 0 0"
          type="password"
          label="新密码"
          :rules="rules.passwordRules"
        />
        <van-field
          v-model="formParams.secondaryPassword"
          style="border-radius: 0 0 16px 16px"
          label="确认新密码"
          type="password"
          :rules="rules.passwordRules"
        />
        <div class="bottom">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            color="#616edf"
            class="formClass_btn"
          >确 定</van-button>
          <p style="color: #ff9e3d; font-size: 0.28rem; margin-bottom: 0.2rem">
            温馨提示：
          </p>
          <p style="font-size: 0.26rem; line-height: 0.4rem; color: #878787">
            为了保护您账号的安全，请不要将雷霆游戏登录的密码设为与其他网站（如：论坛、邮箱、聊天工具等）相同的密码。
          </p>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import headerItem from '@/views/accountCenter/common/header'
import sendCode from '@/mixins/sendCode'
import { ltCaptcha } from '@/utils/ltCaptcha'
import * as api from '@/api/account-center-manage/accountInfo'
import rules from '@/mixins/validator'
export default {
  name: 'EditPhoneNum',
  components: {
    headerItem
  },
  mixins: [sendCode],
  props: {
    headShow: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      key: 'ltCaptchaLogin2',
      titleArray: ['', '首页', '账号管理中心', ''],
      username: '',
      successFlag: false,
      checked: false,
      rules: rules,
      currentIndex: 0,
      userInfo: {
        label: '手机号'
      },
      formParams: {}
    }
  },
  created() {
    if (this.$route.query.type == 'PWD_MODIFY') {
      this.getUserInfo()
      this.titleArray[0] = this.titleArray[3] = '修改密码'
    } else {
      // debugger
      this.titleArray[0] = this.titleArray[3] = '找回密码'
      this.titleArray[2] = '账号自助管理'
    }
  },
  mounted() {
    if (this.$isFlag) {
      document.querySelector('.editPhoneNum').className = ['editPhoneNum editPhoneNumH5 accountCommonH5']
    } else {
      document.querySelector('.editPhoneNum').className = ['editPhoneNum editPhoneNumWeb accountCommonWeb']
    }
  },
  methods: {
    getUserInfo() {
      api.info().then((res) => {
        if (res && res.status == 0) {
          this.userInfo = res.data
          if (this.userInfo.isBindPhone) {
            this.userInfo.label = '已绑手机号'
          } else {
            this.userInfo.label = '手机号'
          }
        }
      })
    },
    async onSubmit() {
      const params = { ...this.formParams }
      if (this.formParams.secondaryPassword != this.formParams.password) {
        this.$msg('两次输入的密码不一致')
        return
      }
      delete params.secondaryPassword
      let res
      if (this.$route.query.type == 'PWD_MODIFY') {
        res = await api.modify_pwd_aes(params)
        this.$ssd.track('leiting_accountmanage_modify')
      } else {
        params.phone = this.userInfo.phone
        res = await api.phone_pwd_back_aes(params)
        this.$ssd.track('leiting_accountmanage_confirm')
      }
      if (res.status == 0) {
        this.successFlag = true
        this.$msg(res.message, 'success')
        if (this.$route.query.type == 'PWD_MODIFY') {
          setTimeout(() => {
            this.$store.dispatch('authLogin/saveIslogin', '0')
            window.ltlAccount.logout()
            // this.$router.go(0)
          }, 2000)
        }
      }
    },
    goAppeal() {
      this.$router.push('/accountCenter/accountSelf/accountAppeal?stateKey=1')
      this.$ssd.track('leiting_accountmanage_noUse')
    },
    getCode() {
      if (!this.userInfo.phone && !this.userInfo.isBindPhone) {
        this.$msg('请输入手机号')
        return
      }
      ltCaptcha((captcha) => {
        this.$tool.sendCode({
          type: this.$route.query.type,
          phone: this.$route.query.type == 'PWD_MODIFY' ? '' : this.userInfo.phone,
          captcha
        }).then((res) => {
          if (res.status == 0) {
            this.startTimer()
            this.$msg('短信发送成功', 'success')
          }
        })
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';
</style>
<style lang="stylus" scoped>
// h5
  .editPhoneNumH5 {
    font-size: 0.25rem;
    background: #f5f7fa;

    .success {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      img {
        width: 6rem;
      }

      p:nth-child(2) {
        font-size: 0.35rem;
        color: #68cb8b;
        margin: 0.5rem 0 0.35rem;
      }
    }

    .checkbox {
      margin: 0.3rem 0;
    }

    .goAppeal {
      text-align: right;
      margin-bottom: 0.3rem;
      color: #606DE2;
      font-size: 0.26rem;
    }

    .formClass {
      padding: 0.4rem;

      .findTwo {
        .formClass_btn {
          margin: 0.5rem auto;
          width: 92%;
        }

        span {
          font-size: 0.26rem;
        }
      }
    }
  }

// web
  .editPhoneNumWeb {
    padding-bottom: 0.5rem;
    border-radius: 10px;
    background: #fff;
    font-size: 0.25rem;

    .checkbox {
      margin: 0.3rem 0;
      font-size: 0.28rem;
    }

    .success {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      img {
        width: 6rem;
      }

      p:nth-child(2) {
        font-size: 0.35rem;
        color: #68cb8b;
        margin: 0.5rem 0 0.35rem;
      }
    }

    .goAppeal {
      text-align: right;
      /* width: 84%; */
      top: 0.3rem;
      right: 5.5rem;
      z-index: 99;
      /* margin-bottom: 0.3rem; */
      color: #606de2;
      position: absolute;
      font-size: 0.26rem;
    }

    .formClass {
      margin: auto;
      // width: 40%;
    }

    .findTwo {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;

      ::v-deep .van-cell {
        font-size: 0.28rem;
        width: 8rem;
      }

      .bottom {
        p {
          margin: 0.2rem;
        }

        .formClass_btn {
          margin: 0.5rem auto;
          width: 7.4rem;
        }
      }
    }

    .findThree {
      display: flex;
      justify-content: center;
      flex-direction: column;

      img {
        width: 6.34rem;
        margin: auto;
      }

      p {
        color: #606de2;
        font-size: 0.32rem;
        margin: 0.32rem 0;
      }
    }
  }
</style>
